import {
  createListenerMiddleware,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { apiWithAuth } from "./auth";
import { User, LoginResponse } from "../../types/interfaces";

export interface AuthState {
  isAuthenticated?: boolean;
  user?: User | null;
  accessToken?: string | null;
  refreshToken?: string | null;
  webAccessDenied?: boolean;
}

const initialState: AuthState = {
  isAuthenticated: !!localStorage.getItem("accessToken"),
  user: null,
  accessToken: localStorage.getItem("accessToken"),
  refreshToken: localStorage.getItem("refreshToken"),
  webAccessDenied: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    tokenRefreshed: (
      state,
      action: PayloadAction<{ access: string; refresh: string }>,
    ) => {
      state.accessToken = action.payload.access;
      state.refreshToken = action.payload.refresh;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.webAccessDenied = false;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    },
    setWebAccessDenied: (state, action: PayloadAction<boolean>) => {
      state.webAccessDenied = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        apiWithAuth.endpoints.login.matchFulfilled,
        (state, action: PayloadAction<LoginResponse>) => {
          state.isAuthenticated = true;
          state.accessToken = action.payload.access;
          state.refreshToken = action.payload.refresh;
        },
      )

      .addMatcher(apiWithAuth.endpoints.checkAuth.matchFulfilled, (state) => {
        state.isAuthenticated = true;
      })
      .addMatcher(
        apiWithAuth.endpoints.resetPassword.matchFulfilled,
        (state) => {},
      )
      .addMatcher(apiWithAuth.endpoints.checkAuth.matchRejected, (state) => {
        state.isAuthenticated = false;
        state.accessToken = null;
      })
      .addMatcher(apiWithAuth.endpoints.logout.matchFulfilled, (state) => {
        state.isAuthenticated = false;
        state.user = null;
        state.accessToken = null;
        state.refreshToken = null;
      })
      .addMatcher(
        apiWithAuth.endpoints.getUser.matchFulfilled,
        (state, action: PayloadAction<User>) => {
          state.user = action.payload;
        },
      )
      .addMatcher(
        apiWithAuth.endpoints.confirmEmailVerification.matchFulfilled,
        (state, action: PayloadAction<{ message: string; email: string }>) => {
          if (state.user) {
            state.user.email = action.payload.email;
          }
        },
      )
      .addMatcher(
        apiWithAuth.endpoints.refreshToken.matchFulfilled,
        (state, action: PayloadAction<{ access: string; refresh: string }>) => {
          state.accessToken = action.payload.access;
          state.refreshToken = action.payload.refresh;
          state.isAuthenticated = true;
        },
      );
  },
});

export const { tokenRefreshed, logout, setWebAccessDenied } = authSlice.actions;
export default authSlice.reducer;
